/**
 * Today's run day in the country — what a Danish time typed in the editor
 * is translated against (15/10/2026). `dkMinOf` turns a country minute
 * (a seed: the window's end, a drop's planned time) into the Danish minute
 * to store.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type CountryDay, localDateInTz, localToDk } from '@trafficpulse/shared';

/** The day to convert on: the page's run date when it has one, else today in the country. */
export const todayIn = (tz: string | null, runDate?: string | null): CountryDay => ({ tz, runDate: runDate ?? localDateInTz(new Date(), tz ?? 'Europe/Copenhagen') });

export const dkMinOf = (localMin: number, tz: string | null, runDate?: string | null): number => localToDk(localMin, todayIn(tz, runDate)).dkMin;
